module.exports = __webpack_public_path__ + "img/settings-icon.0e6bf5b7.svg";